import { CreateParams } from '..'
import { Group } from 'zrender'
import { createList, createText } from '../helpers'
import { isColorDark } from '@/utils/colors'

type Item = (Tile & { type: 'ranking' })['data'][number]

/**
 * Create a ranking tile.
 */
export function ranking({
    width,
    tile
}: CreateParams<Tile & { type: 'ranking' }>) {
    const grouped = tile.data.reduce((acc, item) => {
        if (acc.has(item.group)) {
            acc.get(item.group)?.push(item)
        } else {
            acc.set(item.group, [item])
        }

        return acc
    }, new Map<string, Item[]>())

    const groups = Array.from(grouped.entries())
    const elements: Group[] = []
    const minOpacity = 0.4

    for (let i = 0; i < groups.length; i++) {
        const [name, items] = groups[i]
        const group = new Group({
            x: (width / groups.length) * i
        })

        const text = createText(name.toUpperCase(), 'lg', width / groups.length)
        group.add(text)

        const color = tile.colors[i]
        const isDark = isColorDark(color)
        const textColor = isDark ? 'white' : 'black'
        const texts = items.map(item => item.name)
        const length = items.length

        const list = createList(texts, (_item, index, textEl) => {
            const rank = items[index].rank
            const ratio = isDark ? length - index : index
            const opacity = minOpacity + ((1 - minOpacity) / length) * ratio
            const el = createText(`#${rank.toString()}`)
            el.setStyle({
                fill: textColor,
                backgroundColor: color,
                fillOpacity: opacity,
                borderRadius: 100,
                padding: 5
            })

            const textHeight = textEl.getBoundingRect().height
            const elHeight = el.getBoundingRect().height

            if (textHeight < elHeight) {
                textEl.y += (elHeight - textHeight) / 2
            }
            return el
        })

        list.y = text.getBoundingRect().height + 10

        group.add(list)

        elements.push(group)
    }

    return elements
}
